// react components
import React from 'react'

// data
import {
    contentTypeModelTypeSite,
    reduxAuthStateSite,
    reduxFormHelpersStateSite,
    reduxModalStateSite,
    reduxTextStateSite,
} from 'data'

// services
import {
    getMediaAllV2Site,
    getMediaBandcampV2Site,
    getMediaSoundcloudV2Site,
    getMediaVimeoV2Site,
    getMediaYoutubeV2Site,
    getFormMetaSite,
} from 'services'

// main
export function getFormtMediaDataSite({
    contentType,
    formState,
    helpers,
    image_only,
    prefixImage,
    prefixLink = '',
    reduxAuth,
    reduxModalSite,
    reduxText,
    setFormState,
    setGetMetaIsLoading,
    setHelpers,
    urltoParse,
}: {
    contentType: contentTypeModelTypeSite
    formState: any
    helpers: reduxFormHelpersStateSite
    image_only: boolean
    prefixImage: string
    prefixLink?: string
    reduxAuth: reduxAuthStateSite
    reduxText: reduxTextStateSite['data']
    setFormState: React.Dispatch<any>
    setGetMetaIsLoading: React.Dispatch<boolean>
    setHelpers: React.Dispatch<reduxFormHelpersStateSite>
    urltoParse: string
    reduxModalSite: reduxModalStateSite
}) {

    if (!urltoParse) return

    // Arte
    if (urltoParse.includes('arte.tv') || urltoParse.includes('arteradio.com') || urltoParse.includes('facebook.com') || urltoParse.includes('giphy.com') || urltoParse.includes('dailymotion.com')) { // Check if platform arte, vimeo, facebook, giphy, dailymotion
        getMediaAllV2Site({
            formState,
            helpers,
            image_only,
            prefixImage,
            prefixLink,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }

    // Bandcamp
    else if (urltoParse.includes('bandcamp.com')) { // Check if platform bandcamp
        getMediaBandcampV2Site({
            formState,
            helpers,
            image_only,
            prefixImage,
            prefixLink,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }

    // Soundcloud
    else if (urltoParse.includes('soundcloud.com')) { // Check if platform soundcloud
        getMediaSoundcloudV2Site({
            formState,
            helpers,
            image_only,
            prefixImage,
            prefixLink,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }

    // Youtube
    else if ((urltoParse.includes('youtu.be') || urltoParse.includes('youtube.com')) && !urltoParse.includes('/@')) { // Check if platform youtube
        getMediaYoutubeV2Site({
            formState,
            helpers,
            image_only,
            prefixImage,
            prefixLink,
            reduxAuth,
            reduxModalSite,
            reduxText,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }

    // Vimeo
    else if (urltoParse.includes('vimeo.com')) { // Check if platform vimeo
        getMediaVimeoV2Site({
            formState,
            helpers,
            image_only,
            prefixImage,
            prefixLink,
            reduxText,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }

    else { // Check if platform not detect
        getFormMetaSite({
            contentType,
            formState,
            helpers,
            noFullRender: true,
            prefixImage,
            prefixLink,
            setFormState,
            setGetMetaIsLoading,
            setHelpers,
            urltoParse,
        })
    }
}
